var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLate(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31.83 31.83",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd31a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.586 18.726l-4.438-3.329v-6.78a1.233 1.233 0 00-2.466 0v7.4a1.23 1.23 0 00.493.986l4.931 3.7a1.233 1.233 0 001.479-1.973z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.915 0A15.915 15.915 0 1031.83 15.915 15.933 15.933 0 0015.915 0zm0 29.365a13.45 13.45 0 1113.45-13.45 13.466 13.466 0 01-13.45 13.45z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLate);
export default ForwardRef;